import { render } from "./CkeditorResizable.vue?vue&type=template&id=689229ae&scoped=true"
import script from "./CkeditorResizable.vue?vue&type=script&lang=js"
export * from "./CkeditorResizable.vue?vue&type=script&lang=js"

import "./CkeditorResizable.vue?vue&type=style&index=0&id=689229ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689229ae"]])

export default __exports__